<div class="trend-chart-legend-container" *ngIf="legends.length" [ngClass]="legendSizeClass[size]">
  <ng-container *ngFor="let legendItem of legends; let i = index">
    <ng-container *ngIf="getIconAndColor(i) as iconData">
      <mat-icon
        [svgIcon]="iconData.icon"
        class="legend-icon"
        [style.color]="iconData.color"
      ></mat-icon>
    </ng-container>
    <span class="legend-label">{{ adjustText(legendItem) }}</span>
  </ng-container>
</div>
